module.exports = __webpack_public_path__ + "img/member_block1.970ef8a5.png";